import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ContractsSection from './components/ContractsSection';
import ProfitSection from './components/ProfitSection';
import VideoSection from './components/VideoSection';
import FloatingLiveToast from './components/FloatingLiveToast';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#050508]">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <VideoSection />
        <ServicesSection />
        <ContractsSection />
        <ProfitSection />
      </main>
      <Footer />
      <FloatingLiveToast />
    </div>
  );
}